import { GridActionHandlerBase } from "./grid-action-handler-base";

/**
 * Reloads the page after an item was saved. If the item occurs on the reloaded page, it will be selected
 */
export class ItemSavedReloadGridActionHandler extends GridActionHandlerBase {
  /**
  * Handles an event
  * @param payload The (untyped) payload. Can also be a callback function
  */
  public handle(payload: any): void{
    const savedOid = payload.m_Item2;

    this.workspace.grid.applyFilter(null, savedOid);
  }
}
